import { useState, useEffect } from 'react'
import { Table } from 'antd'
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc'
import { MenuOutlined } from '@ant-design/icons'
import { arrayMoveImmutable } from 'array-move'

import Styled from './styled'

const DragHandle = sortableHandle(() => <MenuOutlined style={{ cursor: 'grab', color: '#999' }} />)

const SortableItem = sortableElement((props) => <tr {...props} />)
const SortableContainer = sortableContainer((props) => <tbody {...props} />)

export default function MyTable ({
  selection = false,
  sort = false,
  columns = [],
  dataSource = [],
  selectedRowKeys = [],
  onSort = () => null,
  onRowSelectChange = () => null,
  ...other
}) {
  const [items, setItems] = useState([])

  useEffect(() => {
    setItems(dataSource)
  }, [dataSource])

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newItems = arrayMoveImmutable([].concat(items), oldIndex, newIndex).filter((el) => !!el)
      setItems(newItems)
      onSort({ items: newItems })
    }
  }

  const DraggableContainer = (sortableProps) => (
    <SortableContainer
      useDragHandle
      disableAutoscroll
      helperClass='row-dragging'
      onSortEnd={onSortEnd}
      {...sortableProps}
    />
  )

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = items.findIndex((x) => x.index === restProps['data-row-key'])
    return <SortableItem index={index} {...restProps} />
  }

  let displayColumns = columns

  if (sort) {
    displayColumns = [
      {
        title: 'Sort',
        dataIndex: 'sort',
        width: 60,
        className: 'drag-visible',
        render: () => <DragHandle />,
      },
      ...columns,
    ]
  }

  const tableProps = {
    rowKey: 'key',
    dataSource: items,
    columns: displayColumns,
  }

  if (selection) {
    tableProps.rowSelection = {
      selectedRowKeys,
      onChange: onRowSelectChange,
      selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
    }
  }

  if (sort) {
    tableProps.rowKey = 'index'
    tableProps.components = {
      body: {
        wrapper: DraggableContainer,
        row: DraggableBodyRow,
      },
    }
  }

  return (
    <Styled className='table-component'>
      <Table {...tableProps} {...other} />
    </Styled>
  )
}
